import cx from 'classnames';

import FacebookIcon from '~/components/Icons/FacebookIcon';
import InstagramIcon from '~/components/Icons/InstagramIcon';
import LinkedinIcon from '~/components/Icons/LinkedInIcon';
import TiktokIcon from '~/components/Icons/TiktokIcon';
import TwitterIcon from '~/components/Icons/TwitterIcon';
import YoutubeIcon from '~/components/Icons/YoutubeIcon';
import type { Author } from '~/interfaces/author';

interface Props {
  author: Author;
  className?: string;
}

const AuthorIcons = ({ author, className }: Props) => {
  return (
    <div className={cx(className)}>
      {author.twitter_handle && (
        <a target="_blank" rel="noreferrer" href={`https://twitter.com/${author.twitter_handle}`}>
          <TwitterIcon className="h-5 w-5 fill-gray-400" />
        </a>
      )}
      {author.linkedin_url && (
        <a target="_blank" rel="noreferrer" href={author.linkedin_url}>
          <LinkedinIcon className="h-5 w-5 fill-gray-400" />
        </a>
      )}
      {author.youtube_url && (
        <a target="_blank" rel="noreferrer" href={author.youtube_url}>
          <YoutubeIcon className="h-5 w-5 fill-gray-400" />
        </a>
      )}
      {author.tiktok_url && (
        <a target="_blank" rel="noreferrer" href={author.tiktok_url}>
          <TiktokIcon className="h-5 w-5 fill-gray-400" />
        </a>
      )}
      {author.facebook_url && (
        <a target="_blank" rel="noreferrer" href={author.facebook_url}>
          <FacebookIcon className="h-5 w-5 fill-gray-400" />
        </a>
      )}
      {author.instagram_url && (
        <a target="_blank" rel="noreferrer" href={author.instagram_url}>
          <InstagramIcon className="h-5 w-5 fill-gray-400" />
        </a>
      )}
    </div>
  );
};

export default AuthorIcons;
